// extracted by css-extract-rspack-plugin
export default {"SidebarFooter":"fGImS","HeaderButton":"VPTkT"};